/// <amd-module name="TFS/Admin/Groups/Pivots/Settings/Redux/SettingsPivotActions" />
import { createAction, ActionsUnion } from "redux/Utils/ActionHelper";
import { PermissionsGroup, TeamAdmin } from "TFS/Admin/Groups/Common/Contracts";
import { ImageData } from "TFS/Admin/Common/Contracts/AvatarImagePicker.types";
import { Avatar } from "TFS/Admin/Common/Contracts/VSS.Profile";
import { GraphGroup } from "VSS/Platform/Contracts/Graph";
import { MessageCardSeverity } from "VSSUI/MessageCard";
import { TeamMember } from "VSS/Platform/Contracts/WebApi";
import { IIdentity } from "VSSUI/IdentityPicker";
import { SettingsOperation } from "TFS/Admin/Groups/Common/Constants";

export const SettingsPivotActions = {
    initView: (selectedGroup?: PermissionsGroup, isTeamsPage?: boolean) =>
        createAction(SettingsPivotActionTypes.InitView, { selectedGroup, isTeamsPage }),
    initViewSuccess: (avatar: Avatar) => createAction(SettingsPivotActionTypes.InitViewSuccess, avatar),
    changeImageClick: () => createAction(SettingsPivotActionTypes.ChangeImageClick),
    cancelImageClick: () => createAction(SettingsPivotActionTypes.CancelImageClick),
    groupNameEdit: (groupName: string) => createAction(SettingsPivotActionTypes.GroupNameEdit, groupName),
    groupDescriptionEdit: (groupDescription: string) => createAction(SettingsPivotActionTypes.GroupDescriptionEdit, groupDescription),
    saveChangesClick: (groupName: string, groupDescription: string, groupDescriptor: string) =>
        createAction(SettingsPivotActionTypes.SaveChangesClick, { groupName, groupDescription, groupDescriptor }),
    saveImageConfirm: (groupDescriptor: string, resetImage: boolean, imageData: ImageData, groupAvatar?: Avatar) =>
        createAction(SettingsPivotActionTypes.SaveImageConfirm, { groupDescriptor, resetImage, imageData, groupAvatar }),
    saveImageFinished: () => createAction(SettingsPivotActionTypes.SaveImageFinished),
    saveChangesSuccess: () => createAction(SettingsPivotActionTypes.SaveChangesSuccess),
    saveChangesFailure: (resultMessage: string, severity: MessageCardSeverity) =>
        createAction(SettingsPivotActionTypes.SaveChangesFailure, {resultMessage, severity}),
    deleteGroupConfirm: (group: GraphGroup) => createAction(SettingsPivotActionTypes.DeleteGroupConfirm, group),
    settingsOperationStatus: (operation: SettingsOperation, resultMessage: string, severity: MessageCardSeverity, selectedItem: GraphGroup) =>
        createAction(SettingsPivotActionTypes.SettingsOperationStatus, { operation, resultMessage, severity, selectedItem }),
    onDismissMessageCard: () => createAction(SettingsPivotActionTypes.OnDismissMessageCard),

    // Admin management
    getTeamAdminsSuccess: (admins: TeamAdmin[]) => createAction(SettingsPivotActionTypes.GetTeamAdminsSuccess, admins),
    removeAdmin: (admin: TeamMember, selectedGroup: PermissionsGroup) => createAction(SettingsPivotActionTypes.RemoveAdmin, { admin, selectedGroup }),
    removeAdminSuccess: (admin: TeamMember) => createAction(SettingsPivotActionTypes.RemoveAdminSuccess, admin),
    openAddAdminPanel: () => createAction(SettingsPivotActionTypes.OpenAddAdminPanel),
    closeAddAdminPanel: () => createAction(SettingsPivotActionTypes.CloseAddAdminPanel),
    onSaveAdmins: (admins: IIdentity[], selectedGroup: PermissionsGroup, adminAsMember: boolean) =>
        createAction(SettingsPivotActionTypes.SaveAdmins, { admins, selectedGroup, adminAsMember }),
    onSaveAdminsSuccess: (admins: IIdentity[], adminAsMember: boolean) => createAction(SettingsPivotActionTypes.SaveAdminsSuccess, { admins, adminAsMember})
};

export const enum SettingsPivotActionTypes {
    InitView = "SettingsPivot/InitView",
    InitViewSuccess = "SettingsPivot/InitViewSuccess",
    ChangeImageClick = "SettingsPivot/ChangeImageClick",
    CancelImageClick = "SettingsPivot/CancelImageClick",
    GroupNameEdit = "SettingsPivot/GroupNameEdit",
    GroupDescriptionEdit = "SettingsPivot/GroupDescriptionEdit",
    SaveChangesClick = "SettingsPivot/SaveChangesClick",
    SaveImageConfirm = "SettingsPivot/SaveImageConfirm",
    SaveImageFinished = "SettingsPivot/SaveImageFinished",
    SaveChangesSuccess = "SettingsPivot/SaveChangesSuccess",
    SaveChangesFailure = "SettingsPivot/SaveChangesFailure",
    DeleteGroupConfirm = "SettingsPivot/DeleteGroupConfirm",
    SettingsOperationStatus = "SettingsPivot/SettingsOperationStatus",
    OnDismissMessageCard = "SettingsPivot/OnDismissMessageCard",

    // Admin management
    GetTeamAdminsSuccess = "SettingsPivot/GetTeamAdminsSuccess",
    RemoveAdmin = "SettingsPivot/RemoveAdmin",
    RemoveAdminSuccess = "SettingsPivot/RemoveAdminSuccess",
    CloseAddAdminPanel = "SettingsPivot/CloseAddAdminPanel",
    OpenAddAdminPanel = "SettingsPivot/OpenAddAdminPanel",
    SaveAdmins = "SettingsPivot/SaveAdmins",
    SaveAdminsSuccess = "SettingsPivot/SaveAdminsSuccess"
}

export type SettingsPivotActions = ActionsUnion<typeof SettingsPivotActions>;
